import React from 'react';

import useIntegration from '@root/resources/integrations/useIntegration';

import ShopifyNotConnected from './ShopifyNotConnected';
import ShopifyConnected from './ShopifyConnected';

const ShopifyDropDown = ({ setSelectingProduct, openModal }) => {
  const { data, isLoading } = useIntegration('shopify');

  if (isLoading) {
    return (
      <div>
        Loading
      </div>
    );
  }

  if (data && data !== {}) {
    return (
      <ShopifyConnected setSelectingProduct={setSelectingProduct} />
    );
  }

  return (
    <ShopifyNotConnected
      openModal={openModal}
      setSelectingProduct={setSelectingProduct}
    />

  );
};

export default ShopifyDropDown;
